<!--view for chat area that uses messagelist and input-->
<template>
  <div class="flex flex-column h100">
    <MessageList :chat="chat" :messages="messages"></MessageList>
    <MessageInput v-if="chat.queue === 'own'" :disabled="chat.status !== profile.userId || !profile.iam.chatWrite" :chat="chat" :messages="messages"></MessageInput>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import MessageList from '@/components/reception/MessageList';
import MessageInput from '@/components/reception/MessageInput';

export default {
  name: 'ChatArea',
  components: { MessageList, MessageInput },
  props: {
    chat: Object,
    messages: Array,
  },
  computed: {
    ...mapGetters({
      profile: 'profile',
    }),
  },
};
</script>
